import type { TextFieldProps } from './TextField.types';
import classes from './TextField.module.css';
import clsx from 'clsx';
import { Input } from '../Input';

export const TextField = (props: TextFieldProps) => {
    const { id, className, value, name, onChange, disabled, error, label, helperText, required, onKeyDown, placeholder, icon } = props;
    return (
        <div className={clsx(classes.root, className)}>
            <Input
                id={id + '-text-field'}
                type="text"
                value={value}
                onChange={onChange}
                name={name}
                label={label}
                helperText={helperText}
                disabled={disabled}
                status={error ? 'error' : undefined}
                required={required}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                icon={icon}
            />
        </div>
    );
};

TextField.displayName = 'TextField';
